import React from 'react';
import { cloneObject, addItemToArrayOnce } from '../../../common/utils';
import IconWithText from '../../layout/IconWithText';
import {
  allowedButtonProps,
  allowedButtonStyles,
  allowedButtonColors
} from './_allowedPropTypes';

const buttonAppearanceClassNames = {
  normal: 'button',
  link: 'pseudo-link',
  'button-link': 'button-link',
  wrap: 'button-wrap',
  outline: 'button-outline'
};

const Button = (
  {
    onClick,
    type,
    appearance = allowedButtonStyles[0],
    buttonColor = allowedButtonColors[0],
    attributes,
    className = '',
    ariaLabel,
    ariaExpanded,
    iconName,
    letButtonShrink,
    iconAttributes = {},
    pullIconRight,
    buttonContent,
    disabled,
    sameTextAndIconColor,
    isFullWidth,
    hasSubmitButtonMargin
  }
) => {
  const { [appearance]: appearanceClassName } = buttonAppearanceClassNames;

  const classNames = className.split(' ');

  addItemToArrayOnce(classNames, `button-color-${buttonColor}`, true);
  addItemToArrayOnce(classNames, appearanceClassName, true);

  if (!letButtonShrink && buttonContent) {
    addItemToArrayOnce(classNames, 'button-shrink-limited');
  }

  if (sameTextAndIconColor) {
    addItemToArrayOnce(classNames, 'inherited-icon-color');
  }

  if (isFullWidth) {
    addItemToArrayOnce(classNames, 'button-full-width');
  }

  if (hasSubmitButtonMargin) {
    addItemToArrayOnce(classNames, 'button-submit-margin');
  }

  const buttonProps = {
    ...attributes,
    onClick,
    type,
    disabled
  };

  const finalIconAttributes = cloneObject(iconAttributes, {
    fixedWidth: true
  });

  if (classNames.length > 0) {
    buttonProps.className = classNames.join(' ');
  }

  if (ariaLabel || typeof (buttonContent) !== 'string') {
    buttonProps.title = ariaLabel;
    buttonProps['aria-label'] = ariaLabel;
  }

  if (ariaExpanded !== undefined) {
    buttonProps['aria-expanded'] = ariaExpanded;
  }

  return (
    <button {...buttonProps}>
      <IconWithText
        pullIconRight={pullIconRight}
        iconName={iconName}
        iconProps={finalIconAttributes}
        text={buttonContent}
      />
    </button>
  );
};

Button.propTypes = allowedButtonProps;

export default Button;